import { useAuth0 } from '@auth0/auth0-react';

import { IS_ADMIN_CLAIM } from '@/lib/auth0Constants';

// Single source of truth for "show admin UI?" — reads the
// IS_ADMIN_CLAIM custom claim off the ID token (strict `=== true`).
// Purely cosmetic: the API independently verifies the same claim on
// the access token, so hiding/showing here carries no security weight.
export function useIsAdmin(): boolean {
  const { user } = useAuth0();
  return user?.[IS_ADMIN_CLAIM] === true;
}
